import { mapContent } from 'store/system/reducer';
import API from './index';

const api = {
    createAmendmentForm({ amendmentType, amendId, applicationFormId }) {
        // amendmentType = either STUDY_INFO or SITE_INFO
        return API.authAPI({
            url: `/application/create-amendment-application/${applicationFormId}`,
            method: 'POST',
            data: {
                amendId,
                amendmentType: amendmentType === 'study' ? 'STUDY_INFO' : 'SITE_INFO',
            },
        });
    },
    downloadAmendmentForm(formId, actualStudyStartDate, listOfAmendment, uploadTempId) {
        return API.authAPI({
            url: `/generate/export-amendment-form`,
            method: 'POST',
            responseType: 'blob',
            data: {
                appId: formId,
                actualStudyStartDate,
                details: listOfAmendment,
                uploadTempId,
            },
            timeout: 1000 * 60 * 10,
        }).then((resp) => {
            mapContent(resp);
        });
    },
    saveAmendmentForm({ formId, actualStudyStartDate, listOfAmendment, uploadTempId, reSubmitComment }) {
        // const listOfAmendment = {
        //     type: '',
        //     fieldName: '',
        //     currentValue: '',
        //     amendmentValue: '',
        //     proposedBy: '',
        //     increaseRisk: false,
        //     reasonForChanges: '',
        // };

        return API.authAPI({
            url: `/application/save-amendment`,
            method: 'POST',
            data: {
                appId: formId,
                actualStudyStartDate,
                details: listOfAmendment,
                uploadTempId,
                // comment: reSubmitComment,
            },
        });
    },
    submitAmendmentForm({ formId, actualStudyStartDate, listOfAmendment, uploadTempId, reSubmitComment }) {
        // const listOfAmendment = {
        //     type: '',
        //     fieldName: '',
        //     currentValue: '',
        //     amendmentValue: '',
        //     proposedBy: '',
        //     increaseRisk: false,
        //     reasonForChanges: '',
        // };

        return API.authAPI({
            url: `/application/submit-amendment-application`,
            method: 'POST',
            data: {
                appId: formId,
                actualStudyStartDate,
                details: listOfAmendment,
                uploadTempId,
                comment: reSubmitComment,
            },
        });
    },
    compareFormChange(amendmentId) {
        // 471 for debug purpose

        return API.authAPI({
            url: `/application/compare-change/${amendmentId}`,
            // url: `/application/compare-change/471`,
            method: 'GET',
        });
    },
    getAmendmentForm(amendmentId) {
        return API.authAPI({
            url: `/application/get-amendment-form/${amendmentId}`,
            method: 'GET',
        });
    },
    checkAmendmentExist(type, id) {
        return API.authAPI({
            url: `/application/check-amendment-exist`,
            // url: `/application/compare-change/471`,
            method: 'GET',
            params: {
                type,
                id,
            },
        });
    },
};

export default api;
